<template>
  <div class="media-settings-view-form">
    <cv-form>
      <dl class="field-set type-text title">
        <dt class="field-label">{{ t("media_settings_title") }}</dt>
        <dd v-if="!isViewingTranscript" class="field-value">{{ mediaObjectMetadata.title }}</dd>
      </dl>
    </cv-form>

    <cv-inline-notification
      v-if="showTranscriptInlineNotification"
      kind="info"
      :title="t('media_settings_transcript_page_info_text')"
      low-contrast
      hide-close-button
    />

    <media-component
      ref="media"
      :uuid="uuid"
      type="mo"
      :mediatype="mediaType"
      :show-ai-info-icon="false"
      :hide-controls="false"
      :cue-points="cuePoints"
      :restriction="false"
      :copyright="false"
      :from-media-settings="true"
      :strict-mode="strictModeLocal"
      :allow-seek-on-paused="true"
      :is-transcript-enabled="true"
      :transcription-file-version="transcriptionFileVersion"
      :caption-src="captionSrc"
      :is-from-subpage="true"
      @media-loaded="handleMediaLoaded"
      @media-playable="handleMediaPlayable"
      @media-ready="handleMediaReady"
    />
    <cv-form>
      <dl class="field-set type-text description">
        <dt class="field-label">{{ t("media_settings_description") }}</dt>
        <dd v-if="!isViewingTranscript" class="field-value">
          <rich-text class="description" :content="mediaObjectMetadata.description" />
        </dd>
      </dl>
    </cv-form>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from "vue-i18n";
import {
  useMediaSettingEditView,
  MediaSettingsEmit,
} from "@plugins/media/composables/use-media-setting-edit-view.ts";

import RichText from "@plugins/richtext/components/RichText.vue";
import MediaComponent from "@plugins/media/components/MediaComponent.vue";
import { CuePoints } from "@plugins/media/types.ts";
import { useTemplateRef, onMounted } from "vue";

const { t } = useI18n();

const emit = defineEmits<MediaSettingsEmit>();

const mediaRef = useTemplateRef<InstanceType<typeof MediaComponent>>("media");

const props = withDefaults(
  defineProps<{
    params?: { uuid?: string; mediaType?: string; strictMode?: boolean };
    mediaObjectMetadata?: { title?: string; description?: string };
    showTranscriptInlineNotification?: boolean;
    cuePoints?: CuePoints;
    transcriptionFileVersion?: string;
    isViewingTranscript?: boolean;
    captionSrc?: string;
    processingId?: string;
  }>(),
  {
    params: () => ({}),
    mediaObjectMetadata: () => ({}),
    showTranscriptInlineNotification: true,
    cuePoints: undefined,
    transcriptionFileVersion: "",
    isViewingTranscript: true,
    captionSrc: "",
    processingId: "",
  },
);

const {
  uuid,
  mediaType,
  strictModeLocal,
  handleMediaLoaded,
  handleMediaPlayable,
  handleMediaReady,
} = useMediaSettingEditView(props, emit);

onMounted(() => {
  if (mediaRef.value) {
    emit("mediaRef", mediaRef.value);
  }
});
</script>
